// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3ni-o","flipped":"styles-module--flipped--224fj"};